import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
} from "@mui/material";
import { AccountListItem } from "../../../types";
import { mockAccountsList } from "../../../types/genereal";
import { ColumnList, columnsList } from "./columnList";
import { AccountListRow } from "./AccountListRow";
import { TableHeader } from "./TableHeader";
import { AccountListPagination } from "./AccountListPagination";
import { AccountPlanStatus } from "../../../types/enums";

interface DataTableProps {
  columns?: ColumnList[];
  rows: AccountListItem[];
  totalRows?: number;
  page?: number;
  rowsPerPage?: number;
  order?: "asc" | "desc";
  campaign_id: string;
}

export const AccountsListTable = ({
  columns = columnsList,
  rows,
  totalRows,
  campaign_id,
}: DataTableProps) => {
  return (
    <Box>
      <TableContainer>
        <Table
          sx={{
            border: "none",
            background: "white",
            boxShadow: 0,
            tableLayout: "fixed",
          }}
        >
          <TableHead>
            <TableHeader
              isAccountPlanRunning={rows.some(
                ({ account_plan_status }) =>
                  account_plan_status === AccountPlanStatus.in_progress,
              )}
              columns={columns}
            />
          </TableHead>
          <TableBody>
            {(rows.length > 0 ? rows : mockAccountsList).map((row) => (
              <AccountListRow
                key={row.id}
                row={row}
                columns={columns}
                total_companies={rows.length}
                campaign_id={campaign_id!}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <AccountListPagination totalRows={totalRows || 0} />
    </Box>
  );
};
